import * as React from 'react';
import { View, Text } from 'react-native';
import { Button } from 'react-native-elements';
import { styles } from 'styles/components/orderCard';
import OrderCardProps from 'types/components/OrderCardProps';
import useMediumScreen from 'hooks/useMediumScreen';
import { getOrderColorByStatus } from 'types/enums/OrderStatusType';
import { useTranslation } from 'react-i18next';
import { useWindowDimensions } from 'react-native';

export default ({ order, onPress, forVisualization }: OrderCardProps): JSX.Element => {
  const medium = useMediumScreen();
  const { width } = useWindowDimensions();

  const isLargeScreen = width >= 1700;
  const isSmallScreen = width <= 1160;

  const { t } = useTranslation();

  return (
    <>
      <View key={order.id} style={medium ? styles.cardItemLarge : styles.cardItemSmall}>
        <View style={forVisualization ? styles.orderIdVisualization : styles.orderId}>
          <Text
            style={
              forVisualization && [
                isLargeScreen ? styles.orderIdVisualizationSize 
                : isSmallScreen ? styles.orderIdVisualizationSizeSmall
                : styles.orderIdVisualizationSizeMedium,
                { color: getOrderColorByStatus(order.status) }]
            }
          >
            {order.id}
          </Text>
          {order.isDiscount && <Text>{t('discount-order-exclamation')}</Text>}
          <Text
            style={
              forVisualization && [
                isLargeScreen ? styles.orderIdVisualizationDeliverySize
                : styles.orderIdVisualizationDeliverySizeMedium,
                { color: getOrderColorByStatus(order.status) },
              ]
            }
          >
            {order.delivery}
          </Text>
        </View>
        {!forVisualization && (
          <Button
            title={t('view-order')}
            containerStyle={styles.cardBtnContainer}
            buttonStyle={styles.cardBtn}
            titleStyle={styles.cardBtnTitle}
            onPress={() => {
              if (onPress) onPress();
            }}
          />
        )}
      </View>
    </>
  );
};
